import { addBrokerSuccessModalProps, defaultModalProps } from 'modal-tpyes'
import {
  useMediaQuery,
  useTheme,
  Dialog,
  makeStyles,
  Container,
  Typography,
  Box,
  Button,
  Grid,
} from '@material-ui/core'
import React , { useState,  useEffect, Fragment } from 'react'
import { useSelector, StateProps } from 'react-redux'

interface stylesProp {
  useMobileUI:boolean
}

const useStyles = makeStyles((theme)=>({
  root: (props:stylesProp) => ({
    borderRadius: theme.spacing(1) ,
    backgroundColor: "white",
    margin:"0px",
    minWidth: props.useMobileUI? "0":"100%",
    padding:theme.spacing(2),
  }),
  closeIcon : {
    position: "absolute",
    color: theme.palette.primary.main,
    top: theme.spacing(2),
    left: theme.spacing(3),
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  container : {
    padding:theme.spacing(4),
  },
  textBlack : {
    color: "#000"
  },
  textBlackBold : {
    color: "#000",
    fontWeight: "bold"
  },
  confirmSvg: {
    fill: theme.palette.primary.main,
    justifyItems:"center"
},
}))

var timer:any


const AddBrokerSuccessModal:React.FC<defaultModalProps> = ({
  open,
  handleBack,
  handleClose,
  props:modalProps,
}) => {

  const theme = useTheme();
  const useMobileUI = useMediaQuery(theme.breakpoints.up("sm"));
  const styleProps = { useMobileUI: useMobileUI };
  const classes = useStyles(styleProps);
  const [props,setProps] = useState<addBrokerSuccessModalProps>()
  const account = useSelector((state:StateProps)=>state.account)
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (open) setTimeLeft(5);
  }, [open]);
  
  useEffect(() => {
    timer = setTimeout(() => {
      if (timeLeft >= 1 && open) {
        setTimeLeft(timeLeft - 1);
      }
      if (timeLeft === 1 && open) {
        onComplete();
      }
    }, 1000);
    return () => clearTimeout(timer);
  });

  const onClose = () => {
    clearTimeout(timer);
    setTimeLeft(1)
    handleClose()
  }

  const ModalProps = {
    paper: classes.root,
  };

  useEffect(()=>{
    if (modalProps) {
      let props:addBrokerSuccessModalProps = {
        isAddSuccess : modalProps.isAddSuccess,
        brokerUsername: modalProps.brokerUsername,
        message : modalProps.message,
        messageTh : modalProps.messageTh,
        addedBrokerAccount : modalProps.addedBrokerAccount
      }
      setProps(props)
    }
  },[modalProps])

  const onComplete = () => {
    if (open) {
      if (props?.isAddSuccess) {
        handleClose()
        if (account.refetcher.broker) {
          account!.refetcher!.broker()
        } else {
          window.location.reload()
        }
      }
      else handleBack()
    }
  }


  return (
    <Dialog open={open||false}  keepMounted onClose={onClose} classes={ModalProps} maxWidth="xl">
      <Container maxWidth="md" className={classes.container}>
        {!!props&&
        <Grid container direction="column" alignItems="center">
          {props.isAddSuccess?
            <Fragment>
              <svg
                  width="84"
                  height="84"
                  viewBox="0 0 84 84"
                  xmlns="http://www.w3.org/2000/svg"
                  className={classes.confirmSvg}
                >
                  <path d="M61.1252 23.583L33.6668 51.0413L18.7085 36.1247L12.8335 41.9997L33.6668 62.833L67.0002 29.4997L61.1252 23.583ZM42.0002 0.333008C19.0002 0.333008 0.333496 18.9997 0.333496 41.9997C0.333496 64.9997 19.0002 83.6664 42.0002 83.6664C65.0002 83.6664 83.6668 64.9997 83.6668 41.9997C83.6668 18.9997 65.0002 0.333008 42.0002 0.333008ZM42.0002 75.333C23.5835 75.333 8.66683 60.4163 8.66683 41.9997C8.66683 23.583 23.5835 8.66634 42.0002 8.66634C60.4168 8.66634 75.3335 23.583 75.3335 41.9997C75.3335 60.4163 60.4168 75.333 42.0002 75.333Z" />
                </svg>
              <Box mt={2}/>
              <Typography variant="subtitle1" className={classes.textBlack}>คุณเพิ่มบัญชีหุ้นทั้งหมดของ username</Typography>
              <Typography variant="subtitle1" className={classes.textBlackBold}>{props.brokerUsername}</Typography>
              <Typography variant="subtitle1" className={classes.textBlack}>เรียบร้อยแล้ว</Typography>
              <Box mt={3}/>
              <Typography variant="subtitle1" className={classes.textBlack}>หมายเลขบัญชีหุ้นที่ใช้ได้มีดังนี้</Typography>
              <Grid container justifyContent="center">
              {props.addedBrokerAccount?.map((account,index)=>(
                <Fragment key={`add-suc-${account}`}>
                  <Typography key={`${account}`} variant="subtitle1" className={classes.textBlackBold}>{account}</Typography>
                  {(index+1)!==props.addedBrokerAccount?.length&&<Typography variant="subtitle1" className={classes.textBlack} key={`${account}-sep`}>,</Typography>}
                </Fragment>
              ))}
              </Grid>
            </Fragment>
            :
            <Fragment>
                <Typography variant="subtitle1" className={classes.textBlack}>{props.message}</Typography>
            </Fragment>
          }
          <Box mt={3}/>
          <Button 
            variant="contained" 
            color="primary"
            onClick={onComplete}
          >
            <Typography color="textPrimary" variant="body2">
              {props.isAddSuccess? `กลับไปหน้าเดิมใน ${timeLeft} วินาที`:`กลับสู่การเลือก account ใน ${timeLeft} วินาที`}
            </Typography>
          </Button>
        </Grid>}
      </Container>
    </Dialog>
  )
}

export default AddBrokerSuccessModal